import { useCallback, useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles, Popper } from '@material-ui/core';
import Dialog from '../../../../components/Dialog';
import { AddIcon, DropDownIcon, DropUpIcon } from '../../../../components/Icon';
import {
  BED_STATUS_REMARK_COLOR,
  NEW_BED_STATUS_CUBICLE_ITEM_LIST,
  NEW_BED_STATUS_LENGTH,
} from '../../../../comm/constant';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import StyleButton from '../../../../components/StyleButton';
import ServiceOrderBtn from '../../components/ServiceOrder/ServiceOrderBtn';
import { OrderedCleaningService } from '../../components/ServiceOrder';
import WardRemarksPopup from './WardRemarksPopup';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#666666',
  },
  titleRemark: {
    color: '#c0c6cb',
    marginLeft: '0.2rem',
  },
  star: {
    color: '#ff0000',
  },
  input: {
    width: '100%',
    minHeight: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  remarkInput: {
    width: '100%',
    minHeight: '5.375rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    alignItems: 'flex-start',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  addRemarkBtn: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#538fff',
  },
  addIcon: {
    fontSize: '1.2rem',
    marginRight: '0.45rem',
  },
  palette: ({ form }) => ({
    width: '1.375rem',
    height: '1.375rem',
    minWidth: '1.375rem',
    minHeight: '1.375rem',
    borderRadius: '4px',
    border: 'solid 1px #e4e7eb',
    marginRight: '0.75rem',
    backgroundColor: BED_STATUS_REMARK_COLOR[form.remarksColor]?.bgColor ?? '',
  }),
  dropDownIcon: {
    color: '#538fff',
    fontSize: '0.75rem',
  },
  remarkColorPopup: {
    zIndex: '9999',
  },
  colourItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    width: '100%',
    height: '2.875rem',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '1.563rem',
    '&:hover': {
      backgroundColor: '#f5faff',
    },
  },
}));

const UpdateWardStatus = ({ data, handleClose, handleUpdateWardStatus, setPopup }) => {
  const [remarkAnchorEl, setRemarkAnchorEl] = useState(null);
  const [form, setForm] = useState({
    wardStatus: data.status ?? '',
    remarks: data.remark ?? '',
    remarksColor: data.colour ?? '',
  });
  const classes = useStyles({ form });
  const [remarkPopupAnchorEl, setRemarkPopupAnchorEl] = useState(null);

  useEffect(() => {
    setPopup(true);

    return () => setPopup(false);
  }, []);

  const handleForm = useCallback(
    (type, color) => (e) => {
      switch (type) {
        case 'wardStatus':
          setForm((o) => ({ ...o, [type]: e }));
          break;
        case 'remarks':
          setForm((o) => ({ ...o, [type]: e.target.value }));
          break;
        case 'remarksColor':
          setForm((o) => ({ ...o, [type]: color }));
          setRemarkAnchorEl(null);
          break;

        default:
          break;
      }
    },
    []
  );

  const handleRemarkOpen = useCallback(
    (event) => {
      if (remarkAnchorEl) {
        setRemarkAnchorEl(null);
      } else {
        setRemarkAnchorEl(event.currentTarget);
      }
    },
    [remarkAnchorEl]
  );

  const handleSubmit = useCallback(() => {
    handleUpdateWardStatus({
      colour: form.remarksColor,
      floorPlanId: data.floorPlanId,
      remark: form.remarks,
      status: form.wardStatus,
      version: data.version,
      hospCode: data.hospCode,
      wardLocation: data.wardLocation,
    });
  }, [data, form, handleUpdateWardStatus]);

  // remark popup 开关
  const handleRemarkPopup = useCallback(
    (event) => {
      setRemarkPopupAnchorEl(remarkPopupAnchorEl ? null : event.currentTarget);
    },
    [remarkPopupAnchorEl]
  );

  // 关闭remark popup
  const handleCloseRemarkPopup = useCallback(() => {
    setRemarkPopupAnchorEl(null);
  }, []);

  // 选择remark
  const handleSelectRemark = useCallback(
    (remark, color) => () => {
      setForm((o) => ({ ...o, remarks: `${String(o.remarks)} ${String(remark)}`.slice(0, 99), remarksColor: color }));
      setRemarkPopupAnchorEl(null);
    },
    []
  );

  return (
    <>
      <Dialog open={true} title={`Ward ${data.wardLocation}`} handleClose={handleClose} haveFoot={false}>
        <Box display="flex" flexDirection="column" gridGap="1.25rem">
          <Box display="flex" flexDirection="column" gridGap="0.75rem">
            <div className={classes.title}>Ward Status</div>
            <AutoCompleteInput
              freeSolo
              itemList={NEW_BED_STATUS_CUBICLE_ITEM_LIST.CubicleStatus}
              value={form.wardStatus}
              onChange={handleForm('wardStatus')}
            />
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.75rem">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <div className={classes.title}>
                Remarks <span className={classes.titleRemark}>(250 words limited)</span>
              </div>
              <Box display="flex" alignItems="center" gridGap="0.969rem">
                <ButtonBase className={classes.addRemarkBtn} onClick={handleRemarkPopup}>
                  <AddIcon className={classes.addIcon} />
                  Add Remarks
                </ButtonBase>
                <ButtonBase onClick={handleRemarkOpen}>
                  <div className={classes.palette} />
                  {remarkAnchorEl ? (
                    <DropUpIcon className={classes.dropDownIcon} />
                  ) : (
                    <DropDownIcon className={classes.dropDownIcon} />
                  )}
                </ButtonBase>
              </Box>
            </Box>
            <InputBase
              className={classes.remarkInput}
              multiline
              inputProps={{ maxLength: NEW_BED_STATUS_LENGTH.WARD_LOCATION_REMARKS }}
              style={{ height: 'auto' }}
              value={form.remarks}
              onChange={handleForm('remarks')}
            />
          </Box>
          <OrderedCleaningService
            marginLeft="0"
            marginTop="0.55rem"
            tableId={data?.floorPlanId}
            tableName="L"
            reminder={`ward ${data?.wardLocation}`}
          />
          <Box display="flex" gridGap="1.25rem" justifyContent="center" mt="0.55rem">
            <StyleButton text="Cancel" width="12.5rem" onClick={handleClose} />
            <ServiceOrderBtn
              hospCode={data?.hospCode}
              wardLocation={data?.wardLocation}
              version={data?.version}
              tableId={data?.floorPlanId}
              tableName="L"
              closePop={handleClose}
              reminder={`ward ${data?.wardLocation}`}
            />
            <StyleButton text="Update" type="fill" backgroundColor="#28d2ab" width="12.5rem" onClick={handleSubmit} />
          </Box>
        </Box>
      </Dialog>

      {/* remark color popup */}
      <Popper
        className={classes.remarkColorPopup}
        open={Boolean(remarkAnchorEl)}
        anchorEl={remarkAnchorEl}
        placement="bottom-end"
        transition
      >
        <Box
          display="flex"
          flexDirection="column"
          width="10rem"
          border="solid 1px #e4e7eb"
          bgcolor="#fff"
          boxShadow="0 1px 6px 0 rgba(0, 0, 0, 0.12)"
          borderRadius="10px"
          padding="0.5rem 0"
        >
          {NEW_BED_STATUS_CUBICLE_ITEM_LIST.RemarkColor.map((item) => (
            <ButtonBase
              className={classes.colourItem}
              key={item.value}
              onClick={handleForm('remarksColor', item.value)}
            >
              <div className={classes.palette} style={{ backgroundColor: item.color }} /> {item.text}
            </ButtonBase>
          ))}
        </Box>
      </Popper>

      {/* remark popup */}
      <WardRemarksPopup
        anchorEl={remarkPopupAnchorEl}
        handleClose={handleCloseRemarkPopup}
        handleClick={handleSelectRemark}
      />
    </>
  );
};

export default UpdateWardStatus;
